/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProgramStatusBlockTextMngDto { 
    /**
     * The status label
     */
    label: { [key: string]: string; };
    /**
     * The type of the status block text. Represents color of the text.
     */
    variant: ProgramStatusBlockTextMngDto.VariantEnum;
}
export namespace ProgramStatusBlockTextMngDto {
    export type VariantEnum = 'normal' | 'accent';
    export const VariantEnum = {
        Normal: 'normal' as VariantEnum,
        Accent: 'accent' as VariantEnum
    };
}


